/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://www.osim.com.cn",
  "jssAppName": "osim-web-shop-cn",
  "defaultLanguage": "zh-CN",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Tue Jan 13 2026 09:13:49 GMT+0700 (Indochina Time)",
  "gitVersion": "a29187ea82c583acbb2119bb63430c191c86acd8",
  "graphQLEndpoint": "https://www.osim.com.cn/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};